// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_status_container__x3kli {
  align-items: center;
  display: flex;
  justify-content: center;
}

.styles_aprovado__LqUcz {
  background-color: green;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_analise__OLtqD {
  background-color: orange;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_reprovado__wGsIa {
  background-color: red;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_revisando__LHNur {
  background-color: rgb(255, 102, 0);
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_user_pendente__Kgalm {
  background-color: blue;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_loading__fkGLj {
  align-items: center;
  display: flex;
  height: 80vh;
  justify-content: center;
  width: 100vw;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Vinculos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".status_container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.aprovado {\n  background-color: green;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.analise {\n  background-color: orange;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.reprovado {\n  background-color: red;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.revisando {\n  background-color: rgb(255, 102, 0);\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.user_pendente {\n  background-color: blue;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.loading {\n  align-items: center;\n  display: flex;\n  height: 80vh;\n  justify-content: center;\n  width: 100vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status_container": `styles_status_container__x3kli`,
	"aprovado": `styles_aprovado__LqUcz`,
	"analise": `styles_analise__OLtqD`,
	"reprovado": `styles_reprovado__wGsIa`,
	"revisando": `styles_revisando__LHNur`,
	"user_pendente": `styles_user_pendente__Kgalm`,
	"loading": `styles_loading__fkGLj`
};
export default ___CSS_LOADER_EXPORT___;
